import React, { ReactNode } from 'react'
import { OtherTrayItemsProvider } from './OtherTrayItems.context'
import { OtherItem } from './OtherTrayItems.types'

interface OtherTrayItemsContextProviderProps {
  children: ReactNode
  otherItems: OtherItem[]
  setOtherItems: React.Dispatch<React.SetStateAction<OtherItem[]>>
}

const OtherTrayItemsContextProvider: React.FC<
  OtherTrayItemsContextProviderProps
> = ({ children, otherItems, setOtherItems }) => {
  return (
    <OtherTrayItemsProvider items={otherItems} setItems={setOtherItems}>
      {children}
    </OtherTrayItemsProvider>
  )
}

export default OtherTrayItemsContextProvider
